import http from "@/http-common";
import Address, {AddressDTO} from "@/api/Address";
import PostRequestInterface from "@/request/PostRequestInterface";

class AddressService {
    async getAddrsses(): Promise<Address[]> {
        const url = '/customer/ajaxAddress/getCustomerAddresses';
        const response = await http.get<AddressDTO[]>(url);
        return response.data.map(addressDTO => new Address(addressDTO));
    }

    async saveAddress(address: Address): Promise<PostRequestInterface> {
        const url = '/customer/ajaxAddress/saveAddress';
        const addressObject = new Address(address);
        const formData = addressObject.getFormData();
        const response = await http.post<PostRequestInterface>(url, formData);
        return response.data;
    }

    async deleteAddrss(addressId: number): Promise<PostRequestInterface> {
        const url = '/customer/ajaxAddress/deleteAddress';
        const formData = new FormData();
        formData.append('addressId', addressId.toString());
        const response = await http.post<PostRequestInterface>(url, formData);
        return response.data;
    }

    async setAddressAsDefault(addressId: number): Promise<PostRequestInterface> {
        const url = '/customer/ajaxAddress/setAddressAsDefault';
        const formData = new FormData();
        formData.append('addressId', addressId.toString());
        const response = await http.post<PostRequestInterface>(url, formData);
        return response.data;
    }
}

export default new AddressService();